<template>
    <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
      <NavbarComponent />
  
      <div v-if="isLoading" class="flex justify-center items-center py-20">
        <div
          class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
        ></div>
      </div>
      <div v-else-if="!isLoading && talent.talent_id" class="font-inter">
        <div v-if="isAdmin || isManager" class=" ">
          <div class="border-grayLight space-y-6 py-6 h-auto justify-between bg-white  text-grayDark rounded">
            <div class=" my-6">
              <div class="">

								<div  class=" ">
                <div class=" my-6 mx-2  px-6">
  
            <div class="flex w-full rounded-lg py-3 items-start ">
              <div class="flex items-center gap-3">
                <img src="@/assets/dashboard/team-img1.svg" alt= "team" class="w-[88px] h-[88px] rounded-lg" />
                <div>
                  <h1 class="text-[18px] font-medium text-primaryDark">{{ capitalize(talent.user.first_name) }} {{ capitalize(talent.user.last_name) }}</h1>
									<p class="text-[14px] text-grayDark">{{ capitalize(talent.position) }}</p>
									<p v-if="talent.user.date_created" class="text-[14px] text-grayDark">Member since{{ capitalize(talent.user.date_created) }}</p>

                </div>
              </div>
            </div>
					</div>
  
            <div class="p-8 space-y-6 h-[70vh] ">
							<div
          class="mx-auto w-[500px] border border-grayLight rounded-full align-center py-2 px-8 mb-8 flex items-center justify-between bg-white-to-gray">

          <div class="flex space-x-2 items-center">
            <h1 class="text-[20px] text-bodyText font-bold">{{ joinedProjectsCount }}</h1>
            <h1 class="text-[14px] text-grayDark">Total Reports</h1>
          </div>
          <div class="h-8 w-[1px] bg-grayLight"></div>

          <div class="flex space-x-2 items-center">
            <h1 class="text-[20px] text-bodyText font-bold">{{ joinedProjectsCount }}</h1>
            <h1 class="text-[14px] text-grayDark">Total hours</h1>
          </div>

					<div class="flex space-x-2 items-center">
						<p class="text-[20px] text-bodyText font-bold">{{ completedTasksCount }}</p>

            <h1 class="text-[20px] text-bodyText font-bold">{{ joinedProjectsCount }}</h1>
            <h1 class="text-[14px] text-grayDark">Tasks Completed</h1>
          </div>


        </div>

              <TabComponent :tabs="reportsTabs" v-model="activeReportsTab" :compact="false" />
  
                </div>
              </div>
              </div>
  
            </div>
            <TabComponent :tabs="projectDetailsTabs" v-model="activeTab" :compact="false" />

            <div v-if="activeTab === 'All Reports'"
              class="flex ml-auto justify-between mb-7 space-x-6 py-1 text-[14px] rounded-[6px] items-center">
              <div class="flex gap-4 items-center">
                <div class="flex gap-4">
                </div>
                <div class="h-6 w-[1px] bg-grayLight"></div>
              </div>
              <div class="flex space-x-3">
  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </template>
  
  <script>
  import apiClient from '@/axios';
  import NavbarComponent from '../NavbarComponent.vue';
  import eventBus from '@/eventBus';
  import TabComponent from '../profiles/TabComponent.vue';
  
  
  export default {
    name: 'ProjectDetailsComponent',
    components: {
      NavbarComponent,
      TabComponent,      
    },
    data() {
      return {
				completedTasksCount: 0,

        activeTab: localStorage.getItem('activeProjectTab') || 'Tasks',  
        reportsTabs: ['All Reports', 'Recent Reports', 'On Hold Feedback'],
      selectedStatus: "All",
      selectedAssignee: null,
  
        isLoading: false,
        talentEmail: '',
        talentName: '',
        TaskAssignedTo: '',
        isSideMenuOpen: false,
				talent: {

				},
        projectName: '',
        projectDescription: '',
        tasks: [],
        talents: [],
      };
      
    },
    watch: {
      '$route.params.projectId': {
        handler(newProjectId, oldProjectId) {
          if (newProjectId && newProjectId !== oldProjectId) {
            this.fetchProject();
          }
        },
        immediate: true
      },
  
      activeTab: {
        handler(newTab) {
          localStorage.setItem('activeProjectTab', newTab);
        },
      },
      selectedStatus: {
        handler(newStatus) {
          localStorage.setItem(`user_${this.currentUserId}_selectedStatus`, JSON.stringify(newStatus));
        }
      },
  
      selectedAssignee: {
        handler(newAssignee) {
          if (newAssignee) {
            localStorage.setItem(`user_${this.currentUserId}_selectedAssignee`, JSON.stringify(newAssignee));
          } else {
            localStorage.removeItem(`user_${this.currentUserId}_selectedAssignee`);
          }
        },
        deep: true
      }
  
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      isManager() {
        return this.$store.getters.isManager;
      },
      isTalent() {
        return this.$store.getters.isTalent;
      },
      isInvestor() {
        return this.$store.getters.isInvestor;
      },
  
      currentUserId() {
        const currentUser = this.$store.state.user;
        const userId = currentUser ? currentUser.user_id : 'guest';
        return userId;
      },
    },
    methods: {
      applyFiltersOnLoad() {
        eventBus.emit('applyFilters', {
          status: this.selectedStatus,
          assignee: this.selectedAssignee
        });
      },
      setActiveTab(tab) {
        this.activeTab = tab;
      },
      capitalize(text) {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      },
      toggleStatusDropdown() {
        this.showStatusDropdown = !this.showStatusDropdown;
      },
      closeStatusDropdown() {
        this.showStatusDropdown = false;
      },
      setStatusFilter(task_status) {
        this.selectedStatus = task_status;
        this.showStatusDropdown = false;
        console.log("Selected task status updated to:", this.selectedStatus); // Debugging
  
        if (task_status) {
          localStorage.setItem('selectedStatus', JSON.stringify(task_status));
        } else {
          localStorage.removeItem('selectedStatus');
        }
      },
      closeDropdown() {
        this.showAssigneeDropdown = false;
      },
      stopEventPropagation(event) {
        event.stopPropagation();
      },
      toggleAssigneeDropdown() {
        this.showAssigneeDropdown = !this.showAssigneeDropdown;
      },
      setAssigneeFilter(assignee) {
  
        this.selectedAssignee = assignee;
        console.log(assignee)
        // Update the dropdown label
        this.showAssigneeDropdown = false;
  
        if (assignee) {
          localStorage.setItem('selectedAssignee', JSON.stringify(assignee));
        } else {
          localStorage.removeItem('selectedAssignee');
        }
      },
      applyFilters() {
        console.log("Applying Filters:", this.filters);
      },
      openSideMenu(member) {
        this.selectedMember = member;
        this.isSideMenuOpen = true;
      },
      closeSideMenu() {
        this.isSideMenuOpen = false;
        this.selectedReport = null;
        this.successMessage = "";
        this.showSuccess = false;
        this.errorMessage = "";
        this.showError = false;
      },
      setViewMode(mode) {
        this.viewMode = mode;
      },
      emitOpenAddProjectMemberModal() {
        // Emit event with project ID and name
        eventBus.emit('openAddProjectMemberModal', {
          projectId: this.project.project_id,
          projectName: this.project.project_name,
        });
      },
  
			async fetchCompletedTasks() {
      try {
        let totalCompletedTasks = 0;

        if (this.talent && this.talent.projects && this.talent.projects.length > 0) {
          for (const project of this.talent.projects) {
            const response = await apiClient.get(`/web/projects/${project.project_id}/tasks`);
            const tasks = response.data.data || [];

            console.log(`Tasks for project ${project.project_id}:`, tasks);
            // Filter tasks that belong to this talent and are completed
            const completedTasks = tasks.filter(task =>
              task.task_status === 'Completed'
              // task.assigned_to === this.talent.talent_id
            );

            totalCompletedTasks += completedTasks.length;
          }
        }

        this.completedTasksCount = totalCompletedTasks;
        console.log('Total completed tasks:', this.completedTasksCount);
      } catch (error) {
        console.error('Error fetching tasks for projects:', error);
        this.completedTasksCount = 0; // Set to 0 on error
      }
    },
  
      async fetchProject(projectId) {
        try {
          const response = await apiClient.get(`/web/projects/${projectId}`);
          this.project = response.data.data;
          this.projectName = this.project.project_name;
          console.log('project_name', this.projectName)
        } catch (error) {
          if (error.response && error.response.status === 404) {
            // Redirect to 404 page if not found
            this.$router.push({ name: 'NotFound' });
          } else {
            console.error('Error fetching project data:', error);
          }
        } finally {
          this.isLoading = false;
        }
      },

      async fetchTalent(talentId) {
        this.isLoading = true;
        try {
          if (this.isAdmin || this.isManager) {
						const response = await apiClient.get(`/web/talents/${talentId}`);

            this.talent = response.data.data;
          } else if (this.isTalent) {
            const response = await apiClient.get('/web/talent/me');
            const talentData = response.data.data;
            this.talentName = talentData.talent_first_name;
            this.talentEmail = talentData.talent_email;
            this.TaskAssignedTo = talentData.talent_id
          }
  
        } catch (error) {
          console.error('Error fetching talents:', error);
        } finally {
          this.isLoading = false;
        }
      },
      
      clearErrorMessage() {
        this.errorMessage = '';
        this.successMessage = '';
      },
    },
    created() {
      const projectId = this.$route.params.projectId;
      const talentId = this.$route.params.talentId;
  
      this.fetchProject(projectId);
      this.fetchTalent(talentId);
			this.fetchCompletedTasks()

			
    // Get user ID for localStorage keys
    const userId = this.$store.state.user ? this.$store.state.user.user_id : 'guest';
    
    // Load selectedStatus from localStorage
    const savedStatus = localStorage.getItem(`user_${userId}_selectedStatus`);
    if (savedStatus) {
      try {
        this.selectedStatus = JSON.parse(savedStatus);
      } catch (e) {
        console.error('Error parsing selectedStatus from localStorage', e);
      }
    }
    
    // Load selectedAssignee from localStorage
    const savedAssignee = localStorage.getItem(`user_${userId}_selectedAssignee`);
    if (savedAssignee) {
      try {
        this.selectedAssignee = JSON.parse(savedAssignee);
      } catch (e) {
        console.error('Error parsing selectedAssignee from localStorage', e);
      }
    }
    },
    mounted() {
      document.addEventListener("click", this.closeDropdown);
      document.addEventListener("click", this.closeStatusDropdown);
    },
    beforeUnmount() {
      document.removeEventListener("click", this.closeDropdown);
      document.removeEventListener("click", this.closeStatusDropdown);
    },
    
  }
  </script>
  
  <style scoped>
  .smoke-light {
    background-color: rgba(0, 0, 0, 0.5);
  }
  </style>